import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2, AlertTriangle } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const FORMAS_PAGAMENTO = ["Crédito", "Débito", "PIX", "Dinheiro", "Crediário", "Pendente"];

export default function ReceitaPagamentos({
  formasPagamento, adicionarFormaPagamento, removerFormaPagamento, atualizarFormaPagamento, calcularValorTotal, totalProdutos = 0,
}) {
  const totalFormas = calcularValorTotal();
  const divergencia = totalProdutos > 0 && Math.abs(totalProdutos - totalFormas) > 0.01;
  return (
    <div>
      <div className="flex items-center justify-between border-b border-slate-200 pb-2 mb-4">
        <h3 className="text-lg font-semibold text-slate-900">Formas de Pagamento</h3>
        <div className="flex items-center gap-4">
          {totalProdutos > 0 && (
            <span className="text-sm font-medium text-slate-600" data-testid="total-produtos">
              Total dos Produtos: <span className="text-lg text-emerald-700">R$ {totalProdutos.toFixed(2)}</span>
            </span>
          )}
          <span className="text-sm font-medium text-slate-600">
            Formas: <span className="text-lg text-slate-900" data-testid="total-formas">R$ {totalFormas.toFixed(2)}</span>
          </span>
          <Button type="button" variant="outline" size="sm" onClick={adicionarFormaPagamento} data-testid="btn-add-pagamento">
            <Plus className="w-4 h-4 mr-1" /> Adicionar
          </Button>
        </div>
      </div>

      {divergencia && (
        <div className="mb-4 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-700" data-testid="alerta-divergencia">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          As formas de pagamento (R$ {totalFormas.toFixed(2)}) nao batem com o total dos produtos (R$ {totalProdutos.toFixed(2)}).
        </div>
      )}

      <div className="space-y-3">
        {formasPagamento.map((fp, index) => (
          <div key={fp._key || index} className={`flex items-center gap-3 p-3 rounded-lg border ${fp.forma === "Pendente" ? "bg-amber-50 border-amber-300" : "bg-slate-50 border-slate-200"}`}>
            <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="space-y-1">
                <Label className="text-xs text-slate-500">Forma</Label>
                <Select value={fp.forma} onValueChange={(value) => atualizarFormaPagamento(index, "forma", value)}>
                  <SelectTrigger data-testid={`select-forma-${index}`}>
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    {FORMAS_PAGAMENTO.map((forma) => (
                      <SelectItem key={forma} value={forma}>{forma}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-1">
                <Label className={`text-xs ${fp.forma === "Pendente" ? "text-amber-600 font-medium" : "text-slate-500"}`}>
                  {fp.forma === "Pendente" ? "Valor Pendente (R$)" : "Valor (R$)"}
                </Label>
                <Input
                  type="number"
                  step="0.01"
                  placeholder="0.00"
                  value={fp.valor}
                  onChange={(e) => atualizarFormaPagamento(index, "valor", e.target.value)}
                  className={fp.forma === "Pendente" ? "border-amber-400 bg-white" : ""}
                  data-testid={`input-valor-${index}`}
                />
                {fp.forma === "Pendente" && (
                  <p className="text-xs text-amber-600">Valor que falta ser pago pelo cliente</p>
                )}
              </div>

              {fp.forma === "Crédito" && (
                <div className="space-y-1">
                  <Label className="text-xs text-slate-500">Parcelas</Label>
                  <Select value={fp.parcelas?.toString() || ""} onValueChange={(value) => atualizarFormaPagamento(index, "parcelas", parseInt(value))}>
                    <SelectTrigger data-testid={`select-parcelas-${index}`}>
                      <SelectValue placeholder="Parcelas" />
                    </SelectTrigger>
                    <SelectContent>
                      {[...Array(12)].map((_, i) => (
                        <SelectItem key={i + 1} value={(i + 1).toString()}>{i + 1}x</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}
            </div>

            {formasPagamento.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => removerFormaPagamento(index)}
                className="text-red-500 hover:text-red-700 hover:bg-red-50"
                data-testid={`btn-remove-${index}`}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
